import React from 'react'
import HeaderOne from '../component/header/HeaderOne';
import MainHero from '../blocks/section/MainHero';
import LookingFor from '../blocks/section/LookingFor';
import PopularCategory from '../blocks/section/PopularCategory';
import Footer from '../component/footer/Footer';

const Home = () => {
  return (
    <>
     <HeaderOne/>
      <MainHero/>
      <LookingFor/>
      <PopularCategory/>
      <Footer/>
    </>
  )
}

export default Home;